module.exports = function() {
  return new Worker(__webpack_public_path__ + "b3ad2566325933451c3e.worker.js");
};